import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { deleteConditionByIdAction } from 'src/modules/SuperAdmin/store/actions/condition.action';
import { AlertIcon } from 'src/icons';
import { SuperAdminModal } from '../../../baseComponents';

const DeleteCondition = ({ isOpen, setIsOpen, isfilterOn, filterValue }) => {
  const dispatch = useDispatch();
  const { getConditionById } = useSelector((state) => state?.conditionState);

  const initialValues = {
    condition_id: '',
  };

  const sections = [
    {
      heading: (
        <div className="flex items-center mb-4">
          <AlertIcon className="mr-2" />
          {getConditionById?.allow_delete
            ? 'Remove condition'
            : `Cannot delete condition ${getConditionById?.condition_name}`}
        </div>
      ),
      className: 'grid grid-cols-1 gap-4',
      fields: [
        {
          type: 'label',
          title: (
            <>
              <span>
                {getConditionById?.allow_delete ? (
                  'Are you sure you want to remove this condition'
                ) : (
                  <span>
                    <span>You cannot delete condition</span>
                    <span className="font-bold ml-1">
                      {getConditionById?.condition_name}
                    </span>
                    <span className="ml-1">
                      since it is linked to other data
                    </span>
                  </span>
                )}
              </span>
              <span className="font-bold ml-1">
                {getConditionById?.allow_delete
                  ? `${getConditionById?.condition_name} ?`
                  : ''}
              </span>
            </>
          ),
        },
      ],
    },
  ];

  return (
    <SuperAdminModal
      open={isOpen}
      sections={sections}
      closable={false}
      initialValues={initialValues}
      submitButtonText={getConditionById?.allow_delete ? 'Submit' : ''}
      cancelButtonText={getConditionById?.allow_delete ? 'Cancel' : 'Go back'}
      className={'delete-modal'}
      handleCancel={() => {
        setIsOpen(false);
      }}
      handleSubmit={() => {
        dispatch(
          deleteConditionByIdAction(
            getConditionById?.condition_id,
            setIsOpen,
            isfilterOn,
            filterValue
          )
        );
      }}
    />
  );
};

export default DeleteCondition;
